module.exports = __webpack_public_path__ + "static/media/pov_vertex_figure_SmallStellatedDodecahedron.8db28a98.png";